export type FeeMode = 'simple' | 'advanced';

export interface CompareFundReturnValues {
  monthlySavings: number;
  startingAmount: number;
  years: number;
  mode: FeeMode;
  robotAReturn: number;
  robotAFee: number;
  robotBReturn: number;
  robotBFee: number;
}

export interface RobotResult {
  finalAmount: number;
  contributed: number;
  totalReturn: number;
  feeImpact: number;
  netReturnPercent: number;
}

export interface CompareFundReturnResult {
  isValid: boolean;
  message?: string;
  contributed: number;
  robotA: RobotResult;
  robotB: RobotResult;
  difference: number;
  winner: 'a' | 'b' | 'tie';
}

export interface ChartDataPoint {
  year: string;
  robotA: number;
  robotB: number;
}

export function getNumberLocale(): string {
  return process.env.NEXT_PUBLIC_WEBSITE_LOCALE || process.env.WEBSITE_LOCALE || 'sv-SE';
}
